export default __webpack_public_path__ + "static/media/expPurple.c054e793.svg";